export default "__VITE_ASSET__AeJoqMnJ__"